import { createContext, useContext, useLayoutEffect, useMemo, useState } from "react";
import TopBand from "./TopBand";
import "./css/TopBand.css";

const StaffTopBandContext = createContext(null);

export function StaffTopBandProvider({ children }) {
  const [topBand, setTopBand] = useState(null);
  const value = useMemo(() => ({ topBand, setTopBand }), [topBand]);

  return (
    <StaffTopBandContext.Provider value={value}>
      {children}
    </StaffTopBandContext.Provider>
  );
}

export function StaffTopBandSlot({ show, className = "" }) {
  const ctx = useContext(StaffTopBandContext);
  const config = ctx?.topBand;

  if (!show || !config) return null;

  return (
    <div className={`staffTopBandHost ${className}`}>
      <TopBand {...config} />
    </div>
  );
}

export function useStaffTopBand(config, deps) {
  const ctx = useContext(StaffTopBandContext);

  useLayoutEffect(() => {
    if (!ctx?.setTopBand) return;
    if (config === null) return;
    ctx.setTopBand(config);
  }, deps);
}
